var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasolina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 109.25V23C17.25 21.475 17.8558 20.0125 18.9341 18.9341C20.0125 17.8558 21.475 17.25 23 17.25H74.75C76.275 17.25 77.7375 17.8558 78.8159 18.9341C79.8942 20.0125 80.5 21.475 80.5 23V69H92C95.05 69 97.9751 70.2116 100.132 72.3683C102.288 74.5249 103.5 77.45 103.5 80.5V103.5C103.5 105.025 104.106 106.488 105.184 107.566C106.262 108.644 107.725 109.25 109.25 109.25C110.775 109.25 112.238 108.644 113.316 107.566C114.394 106.488 115 105.025 115 103.5V63.25H103.5C101.975 63.25 100.512 62.6442 99.4341 61.5659C98.3558 60.4875 97.75 59.025 97.75 57.5V36.8805L88.2223 27.3527L96.3528 19.2222L124.815 47.6848C125.35 48.218 125.774 48.8516 126.063 49.5493C126.352 50.2469 126.501 50.9948 126.5 51.75V103.5C126.5 108.075 124.683 112.463 121.448 115.698C118.213 118.933 113.825 120.75 109.25 120.75C104.675 120.75 100.287 118.933 97.0524 115.698C93.8174 112.463 92 108.075 92 103.5V80.5H80.5V109.25H86.25V120.75H11.5V109.25H17.25ZM28.75 28.75V63.25H69V28.75H28.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolina);
export default __webpack_public_path__ + "static/media/gasolina.2d02c9196bb589a3cec22dd990cbedc0.svg";
export { ForwardRef as ReactComponent };